// extracted by mini-css-extract-plugin
module.exports = {"downloadContainer":"Form_downloadContainer__7APLT","buttonCheckBox":"Form_buttonCheckBox__ee6w9","CheckboxButton":"Form_CheckboxButton__1Ks96"};